// RxJS
import { of } from 'rxjs';
import { catchError, finalize, tap, debounceTime, delay, distinctUntilChanged } from 'rxjs/operators';
// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../_base/crud';
// State
import { AppState } from '../../core/reducers';
import { selectUnitTypeInStore, selectUnitTypePageLoading, selectUnitTypeShowInitWaitingMessage } from './unittype.selector';


export class UnitTypeDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
		super();

		this.loading$ = this.store.pipe(
			select(selectUnitTypePageLoading)
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectUnitTypeShowInitWaitingMessage)
		);

		this.store.pipe(
			select(selectUnitTypeInStore)
		).subscribe((response: QueryResultsModel) => {
			this.paginatorTotalSubject.next(response.totalCount);
			this.entitySubject.next(response.items);
		});
	}
}
